import React, { useEffect, useState } from 'react';
import { apiGET } from '../../utilities/apiHelpers';
import { useNavigate } from 'react-router-dom';
import SimpleLoader from '../Loader/SimpleLoader';

const ViewallBrands = () => {
    const navigate = useNavigate();

    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const LIMIT = 10;

    const fetchBrands = async (page) => {
        try {
            setLoading(true);

            const res = await apiGET(`v1/brand/all?page=${page}&limit=${LIMIT}`);

            if (res?.data?.status) {
                const { brands, totalPages } = res.data.data;

                setBrands(brands || []);
                setTotalPages(totalPages || 1);
            }
        } catch (err) {
            console.error('Failed to load brands:', err);
        } finally {
            setLoading(false);
        }
    };

    // Fetch whenever page changes
    useEffect(() => {
        fetchBrands(currentPage);
    }, [currentPage]);

    const goToPage = (page) => {
        if (page < 1 || page > totalPages || page === currentPage) return;

        setCurrentPage(page);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    if (loading) return <SimpleLoader />;

    return (
        <div className='min-h-screen bg-white p-6 md:p-12'>
            <div className='max-w-7xl mx-auto'>
                <div className='flex justify-between items-center mb-8'>
                    <h1 className='text-2xl font-bold'>All Brands</h1>
                    <span className='text-sm text-gray-500'>
                        Page {currentPage} of {totalPages}
                    </span>
                </div>

                {/* Brand Grid */}
                <div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4'>
                    {brands.map((brand) => (
                        <div
                            key={brand.id}
                            onClick={() => navigate(`/product/brand/${brand.id}`)}
                            className='border rounded-xl p-4 flex flex-col items-center hover:shadow-md cursor-pointer transition-all'
                        >
                            <img
                                src={brand.brandImgUrl}
                                alt={brand.name}
                                className='w-24 h-24 object-contain mb-2'
                            />
                            <p className='text-sm font-semibold text-center truncate w-full'>
                                {brand.name}
                            </p>
                        </div>
                    ))}
                </div>

                {/* Pagination */}
                <div className='mt-12 flex justify-center gap-2 flex-wrap'>
                    <button
                        onClick={() => goToPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        className='px-4 py-2 border rounded disabled:opacity-50'
                    >
                        Prev
                    </button>

                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                        <button
                            key={page}
                            onClick={() => goToPage(page)}
                            className={`w-10 h-10 border rounded
                                ${currentPage === page
                                    ? 'bg-[#14967F] text-white'
                                    : 'hover:bg-gray-100'
                                }`}
                        >
                            {page}
                        </button>
                    ))}

                    <button
                        onClick={() => goToPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className='px-4 py-2 border rounded disabled:opacity-50'
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewallBrands;
